<template>
  <v-alert class="nitro">
    <v-row
      align="center"
      no-gutters
    >
      <v-col class="grow">
        <p class="m-0 white--text">
          {{ title }}
        </p>
        <p class="small m-0 white--text mr-4">
          {{ subtitle }}
        </p>
      </v-col>
      <v-col class="shrink">
        <i class="fas fa-check-circle fa-2x white--text" />
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>

export default {
  props:{
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    }
  },
}
</script>